export default __webpack_public_path__ + "static/Kayla-Knight-350x350-97dbe3e104df968617cec39fd4ac6a60.jpg";